import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { COLORS, FONT_FAMILY } from '../../../../../app/common/constants/styles';

type IPaymentOutterInputProps = {
    'data-qa-id'?: string;
    id?: string;
    field?: string;
    showError: boolean | undefined;
    showWarning?: boolean;
    focus: boolean;
    children?: ReactNode;
};

const Wrapper = styled.div<IPaymentOutterInputProps>`
    box-sizing: border-box;
    border: 1px solid
        ${({ showError, showWarning, focus }) => {
            if (showError) return COLORS.redTitle;
            if (showWarning) return COLORS.warning;
            if (focus) return COLORS.redTitle;
            return COLORS.dark2;
        }};
    border-radius: 0.32rem;
    ${FONT_FAMILY.multipleRegularCss};
    font-weight: 300;
    width: 100%;
    height: 2.5rem;
    display: flex;
    align-items: center;
    padding: 0 ${({ field }) => (field === 'card' ? '0' : '0.5rem')};
    outline: ${({ focus, showError, showWarning }) => {
        if (focus) {
            if (showError) return `1px solid ${COLORS.redTitle}`;
            if (showWarning) return `1px solid ${COLORS.warning}`;
            return `1px solid ${COLORS.redTitle}`;
        }
        return 'none';
    }};
    .wide {
        width: 100%;
    }
`;
const PaymentOutterInput: React.FC<IPaymentOutterInputProps> = (props) => {
    return (
        <Wrapper {...props} role="textbox">
            {props.children}
        </Wrapper>
    );
};

export default PaymentOutterInput;
